import PropTypes from 'prop-types';
import './Button.css';

export function Button({
  variant = 'secondary',
  size = 'md',
  disabled = false,
  type = 'button',
  onClick,
  children,
  className = '',
  'aria-label': ariaLabel,
}) {
  return (
    <button
      type={type}
      aria-label={ariaLabel}
      className={`btn btn-${size} btn-${variant}${className ? ` ${className}` : ''}`}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  'aria-label': PropTypes.string,
  variant: PropTypes.oneOf([
    'primary',
    'seal',
    'secondary',
    'ghost',
    'danger',
    'danger-solid',
  ]),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  onClick: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Button;
